<template>
  <div
    id="app"
    :style="{
      opacity: showMenu ? '1' : '0'
    }"
    style="touch-action:manipulation"
  >
  <!--
    <b-navbar
      toggleable="md"
      type="dark"
      class="custom-navbar"
      fixed="top"
    >
      <b-navbar-toggle target="nav-collapse" class="ml-auto"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item class="menu-button">
            <router-link
              class="nav-link"
              to="/"
              href="#header"
              v-smooth-scroll="{
                duration: 1000
              }"
              >{{this.$t('text.home')}}</router-link
            >
          </b-nav-item>
          <b-nav-item class="menu-button">
            <router-link class="nav-link" to="/large-cabin" href="#header">
              {{$t('text.large_cabin')}}
            </router-link>
          </b-nav-item>
          <b-nav-item class="menu-button">
            <router-link class="nav-link" to="/small-cabin" href="#header">
              {{$t('text.small_cabin')}}
            </router-link>
          </b-nav-item>
          <b-nav-item class="menu-button">
            <router-link class="nav-link" to="/book" href="#header">
              {{$t('text.book')}}
            </router-link>
          </b-nav-item>
        </b-navbar-nav>
        
        <b-navbar-nav class="ml-auto">

          <b-nav-item-dropdown class="nav-link menu-button" v-bind:text="$root.$i18n.locale" left>
            <b-dropdown-item class="menu-button" @click="setLocale('se')">se</b-dropdown-item>
            <b-dropdown-item class="menu-button" @click="setLocale('en')">en</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item v-if="isAdmin" class="menu-button">
            <router-link class="nav-link" to="/admin/bookings">{{this.$t('text.admin')}}</router-link>
          </b-nav-item>
          <b-nav-item v-if="!isLoggedIn" class="menu-button">
            <router-link class="nav-link" :to="'/login?redirect=' + $router.currentRoute.fullPath">{{this.$t('text.login')}}</router-link>
          </b-nav-item>
          <b-nav-item-dropdown v-if="isLoggedIn" class="nav-link menu-button" v-bind:text="getFirstName" right>
            <b-dropdown-item class="menu-button" to="/profile">{{this.$t('text.profile')}}</b-dropdown-item>
            <b-dropdown-item class="menu-button" @click="logout">{{this.$t('text.Logout')}}</b-dropdown-item>
          </b-nav-item-dropdown>
          
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
-->
    <router-view id="router-view"/>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "App",
  data() {
    return {
      scrollY: 0,
      showMenu: true,
      menuIsOpen: false,
    };
  },
  created: function() {
    window.addEventListener("scroll", this.handleScroll);
    this.$http.interceptors.response.use(undefined, function(err) {
      return new Promise(function() {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch("logout");
        }
        throw err;
      });
    });
    /*if (!this.$store.getters.token_valid) {
      console.log("LOGGING OUT, TOKEN INVALID");
      this.logout();
    } else {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$store.getters.token.access_token;
    }*/
    if (this.$store.getters.token_valid) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$store.getters.token.access_token;
    }
  },
  mounted() {
    this.showMenu = true;
    let divWithEvent = document.getElementById("app");
    divWithEvent.addEventListener('click', this.onClick);
    this.$root.$on('bv::collapse::state', (_, isJustShown) => {
      this.menuIsOpen = isJustShown;
    })
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll);
    let divWithEvent = document.getElementById("app");
    divWithEvent.removeEventListener('click', this.onClick);
  },
  computed: {
    getFirstName() {
      return this.$store.getters.user ? this.$store.getters.user.first_name : ""
    },
    isLoggedIn: function() {
      return (
        this.$store.getters.token_valid &&
        this.$store.getters.isLoggedIn
      );
    },
    isFamily() {
      if (!this.$store.getters.user) { return false }
      return (
        this.$store.getters.token_valid &&
        this.$store.getters.isLoggedIn && 
        this.$store.getters.user.clearance > 0
      );
    },
    isAdmin() {
      if (!this.$store.getters.user) { return false }
      return (
        this.$store.getters.token_valid &&
        this.$store.getters.isLoggedIn && 
        this.$store.getters.user.clearance > 2
      );
    },
  },
  methods: {
    logout: function() {
      this.$store.dispatch("logout").then(() => {
        this.$router.go();
      });
    },
    handleScroll() {
      this.scrollY = window.scrollY;
    },
    setLocale(locale) {
      this.$root.$i18n.locale = locale;
    },
    onClick(event) {
      if (this.menuIsOpen && !event.target.className.includes("navbar")) {
        this.$root.$emit('bv::toggle::collapse', 'nav-collapse')
      }
    }
  }
};
</script>

<style>
#app {
  height: 100%;
  width: 100%;
  -webkit-transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -ms-transition: opacity 1s ease-in-out;
  -o-transition: opacity 1s ease-in-out;
  transition: opacity 1s ease-in-out;
}

.nav-link {
  color: white;
}

.menu-button {
  text-align: right;
}

.custom-navbar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #000;
  -webkit-transition: opacity 1.5s ease-in-out;
  -moz-transition: opacity 1.5s ease-in-out;
  -ms-transition: opacity 1.5s ease-in-out;
  -o-transition: opacity 1.5s ease-in-out;
  transition: opacity 1.5s ease-in-out;
}

a:hover {
  cursor: pointer;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
